import { useSelectorMachineContext } from '@printdeal/product-selector';

type Orchestration = {
  id: string;
};

/**
 * Retrieves the orchestration information from the derived product attributes of the selector.
 * @returns The orchestration object if found, otherwise undefined.
 */
export const useOrchestration = (): Orchestration | undefined => {
  const productAttributes = useSelectorMachineContext((state) => state.context.productAttributes);
  const orchestrationIdAttribute = productAttributes.find((attribute) => attribute.key === 'Orchestration Id');

  if (orchestrationIdAttribute?.resolvedValue && orchestrationIdAttribute.resolvedValue !== 'None') {
    return {
      id: orchestrationIdAttribute.resolvedValue,
    };
  }

  return undefined;
};
